(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.header.classList.contains('menu-open')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const initializeCollectionDescriptions = (scope) => {
    scope.querySelectorAll('[data-collection-description]').forEach((container) => {
      if (container.dataset.initialized === 'true') return;

      const toggle = container.querySelector('[data-collection-description-toggle]');
      const copy = container.querySelector('[data-collection-description-copy]');
      if (!toggle || !copy) return;

      const walker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT);
      let textNode;
      let sentenceEnd;

      while ((textNode = walker.nextNode())) {
        const match = /[.!?](?=\s|$)/.exec(textNode.textContent);
        if (match) {
          sentenceEnd = { node: textNode, offset: match.index + 1 };
          break;
        }
      }

      if (!sentenceEnd) return;

      const range = document.createRange();
      range.setStart(sentenceEnd.node, sentenceEnd.offset);
      range.setEnd(copy, copy.childNodes.length);
      if (!range.toString().trim()) return;

      const remaining = document.createElement('div');
      remaining.id = `${copy.id}-more`;
      remaining.className = 'cc-collection-description__more rte';
      remaining.hidden = true;
      remaining.appendChild(range.extractContents());
      container.insertBefore(remaining, toggle);

      container.dataset.initialized = 'true';
      toggle.setAttribute('aria-controls', remaining.id);
      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        const isExpanded = remaining.hidden;
        remaining.hidden = !isExpanded;
        toggle.setAttribute('aria-expanded', String(isExpanded));
        toggle.textContent = isExpanded ? container.dataset.lessLabel : container.dataset.moreLabel;
        toggle.setAttribute('aria-label', isExpanded ? container.dataset.lessLabel : container.dataset.moreLabel);
      });
    });
  };

  const initializeCollectionDescriptionsWhenReady = () => initializeCollectionDescriptions(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionDescriptionsWhenReady, { once: true });
  } else {
    initializeCollectionDescriptionsWhenReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeCollectionDescriptions(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
